export default {
      id: "certificate-usage",
      viewBox: "0 0 70 58",
      url: "/dist/svg/" + "sprite.svg#certificate-usage",
      toString: function () {
        return this.url;
      }
    }